/**
 *
 */
export default class LocalizedInformationAlternateLanguage {
    /**
     * Gets the current alternate languages as an array.
     *
     * @param settings ...
     * @param settings.localisation ...
     * @param settings.localisation.alternateLanguages ...
     * @param locale ...
     * @returns Current language options.
     */
    static getAlternateLanguages(settings, locale) {
        if (settings) {
            const [, country] = locale.split('-');
            const alternateLanguages = 'localisation' in settings
                ? settings.localisation.alternateLanguages
                : settings.localization.alternateLanguages;
            return alternateLanguages
                .split(';')
                .reduce((accumulator, language) => {
                const [value, label] = language.split(':');
                if (label) {
                    accumulator.push({ locale: `${value.toLowerCase()}-${country}`, label });
                }
                return accumulator;
            }, []);
        }
        return [];
    }
}
//# sourceMappingURL=LocalizedInformationAlternateLanguage.js.map